module.exports = __webpack_public_path__ + "static/img/human-5.2fa7dacc.png";